import React, { useState, useEffect } from 'react'
import { getEmiDetailsApi } from '../../CommunityActionCreator'
import { useLocation } from 'react-router-dom';
import moment from 'moment';
const EmiDetails = ({rowData}) => {
    const [emiData, setemiData] = useState('')
    const location = useLocation();


    useEffect(() => {
       EmiDataApi()
    }, [])
    const EmiDataApi =()=>{
        getEmiDetailsApi(rowData.loanId, callBack => {
            setemiData(callBack)
        }, error => {

        })
    }
    return (
        <div className='container-fluid full-height'>

            <div className='row mt-3'>

                <div style={{ overflowX: 'auto' }}>
                    <table className='table credhub-table'>
                        <thead>
                            <tr>
                                <th scope="col">Date</th>

                                <th scope="col">EMI Amount</th>
                                <th scope="col">EMI Paid Amount</th>

                                {/* <th scope="col">Status</th> */}
                                <th scope="col">Paid Date</th>
                                <th scope="col">Loan Status</th>

                            </tr>
                        </thead>
                        <tbody>
                            {emiData && emiData.map((row, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{moment(row.date).format("DD MMM YYYY")}</td>
                                        <td>{row.emiAmt}</td>
                                        <td>{row.emiPaidAmt}</td>
                                        {/* <td>{row.status}</td> */}
                                        <td>{row.paidDate?moment(row.paidDate).format("DD MMM YYYY"):""}</td>
                                        <td>{row.loanStatus}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default EmiDetails;